"use client";

import { ArrowRight } from "lucide-react";
import Link from "next/link";
import type { ReactElement } from "react";
import { CAREERS_CONTENT } from "./careers-content";
import { useCareersLanguage } from "./careers-language-context";

/** Dark type-first hero: headline, intro, fact chips, one CTA. */
export function CareersHero(): ReactElement {
  const { lang } = useCareersLanguage();
  const t = CAREERS_CONTENT[lang].hero;

  return (
    <section className="c2-hero">
      <div className="c2-hero-inner">
        <h1 className="c2-hero-title">{t.title}</h1>

        <p className="c2-hero-intro c2-hero-intro-desk">{t.intro}</p>
        <p className="c2-hero-intro c2-hero-intro-mobile">{t.introMobile}</p>

        <ul className="dvf-facts">
          {t.facts.map((fact) => (
            <li className="dvf-fact" key={fact}>
              {fact}
            </li>
          ))}
        </ul>

        <div className="c2-hero-cta">
          <Link href="#jobs" className="c2-btn c2-btn-lg">
            {t.cta}
            <ArrowRight size={17} strokeWidth={2.2} />
          </Link>
        </div>
      </div>
    </section>
  );
}
